import { render } from "./VoucherView.vue?vue&type=template&id=6f7fb12c&scoped=true"
import script from "./VoucherView.vue?vue&type=script&lang=js"
export * from "./VoucherView.vue?vue&type=script&lang=js"

import "./VoucherView.vue?vue&type=style&index=0&id=6f7fb12c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7fb12c"]])

export default __exports__